import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {salesTerminalRoutes} from './sales-terminal.route';
import {EventSearchComponent} from './event-search/event-search.component';
import {SharedModule} from '../../shared/shared.module';
import {RouterModule} from '@angular/router';
import {CardItemComponent} from './event-search/card-item/card-item.component';
import {TableItemComponent} from './event-search/table-item/table-item.component';
import {EventService} from '../../services/event/event.service';
import {SalespointsService} from '../../services/salespoints/salespoints.service';
import {CartComponent} from './cart/cart.component';
import {CartTableComponent} from './cart/table/cart-table.component';
import {CartActionsComponent} from './cart/actions/cart-actions.component';
import {CartTotalsComponent} from './cart/totals/cart-totals.component';
import {CartModalsComponent} from './cart/modals/cart-modals.component';
import {EventDetailsDialogComponent} from '../../components/event-details-dialog/event-details-dialog.component';
import {VenueMapComponent} from '../../components/venue-map/venue-map.component';
import {EventPurchaseComponent} from './event-purchase/event-purchase.component';
import {ScrapComponent} from './scrap/scrap.component';
import {TransactionsComponent} from './transactions/transactions.component';
import {RefundComponent} from './refund/refund.component';
import {TransactionsService} from '../../services/transactions/transactions.service';
import {BookingsListComponent} from './bookings/list/bookings-list.component';
import {BookingsViewComponent} from './bookings/view/bookings-view.component';
import {BookingsService} from '../../services/bookings/bookings.service';
import {CustomerService} from '../../services/customer/customer.service';
import {BookingsCreateModalComponent} from './bookings/create-modal/bookings-create-modal.component';
import {LegalPersonService} from '../../services/legalPerson/legalPerson.service';
import {EventOwnerWarningDialogComponent} from '../../components/event-owner-warning-dialog/event-owner-warning-dialog.component';
import {ConfigureEmailDialogComponent} from '../../components/configure-email-dialog/configure-email-dialog.component';
import {PromoterService} from '../../services/promoter/promoter.service';
import {TransactionDetailComponent} from './transactions/details/transaction-detail.component';
import {InvoiceGenerateModalComponent} from './transactions/invoice-modal/invoice-generate-modal.component';
import {EmailModalComponent} from './transactions/email-modal/email-modal.component';
import {CustomerViewComponent} from '../../components/customer-view/customer-view.component';
import {RefundDialogComponent} from './event-purchase/refund-dialog/refund-dialog.component';
import {MobileCardItemComponent} from "./event-search/mobile-card-item/mobile-card-item.component";
import {TicketSelectHeaderComponent} from './event-purchase/ticket-select-header/ticket-select-header.component';
import {TicketSelectComponent} from './event-purchase/ticket-select/ticket-select.component';
import {SelectedTicketsComponent} from './event-purchase/selected-tickets/selected-tickets.component';
import {TicketSelectSectorComponent} from './event-purchase/ticket-select-sector/ticket-select-sector.component';
import {CountryService} from '../../services/country/country.service';
import {TicketSelectTypesComponent} from './event-purchase/ticket-select-types/ticket-select-types.component';
import {DialogService} from '../../services/dialog/dialog.service';
import {TransactionsFiltersComponent} from "./transactions/filters/transactions-filters.component";
import {TransactionRefundModalComponent} from "./transactions/refund-modal/transaction-refund-modal.component";
import {DirtyStateTrackerService} from '../../services/dirty-state-tracker/dirty-state-tracker.service';
import {PaymentReversalComponent} from "./payment-reversal/payment-reversal.component";
import {PaymentReversalFiltersComponent} from "./payment-reversal/filters/payment-reversal-filters.component";
import {PaymentReversalRefundConfirmationComponent} from "./payment-reversal/refund-confirmation/payment-reversal-refund-confirmation.component";
import {TicketsComponent} from './tickets/tickets.component';
import {TicketComponent} from './tickets/ticket/ticket.component';
import {QRCodeModule} from 'angularx-qrcode';

@NgModule({
  declarations: [
    EventSearchComponent,
    CardItemComponent,
    MobileCardItemComponent,
    TableItemComponent,
    CartComponent,
    CartTableComponent,
    CartActionsComponent,
    CartTotalsComponent,
    CartModalsComponent,
    EventDetailsDialogComponent,
    VenueMapComponent,
    EventPurchaseComponent,
    ScrapComponent,
    TransactionsComponent,
    RefundComponent,
    BookingsListComponent,
    BookingsViewComponent,
    BookingsCreateModalComponent,
    EventOwnerWarningDialogComponent,
    ConfigureEmailDialogComponent,
    TransactionDetailComponent,
    InvoiceGenerateModalComponent,
    EmailModalComponent,
    CustomerViewComponent,
    RefundDialogComponent,
    TicketSelectHeaderComponent,
    TicketSelectComponent,
    SelectedTicketsComponent,
    TicketSelectSectorComponent,
    TicketSelectTypesComponent,
    TransactionsFiltersComponent,
    TransactionRefundModalComponent,
    PaymentReversalComponent,
    PaymentReversalFiltersComponent,
    PaymentReversalRefundConfirmationComponent,
    TicketsComponent,
    TicketComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(salesTerminalRoutes),
    QRCodeModule,
  ],
  providers: [
    EventService,
    PromoterService,
    TransactionsService,
    BookingsService,
    CustomerService,
    SalespointsService,
    LegalPersonService,
    CountryService,
    DialogService,
    DirtyStateTrackerService
  ]
})
export class SalesTerminalModule {
}
